var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Location_Switcher") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header/Login",
    transform: "translate(-165.000000, -57.000000)",
    fill: "#A5A5A5",
    stroke: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(150.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Location_Switcher",
    transform: "translate(16.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,7.14529915 C4.59188034,7.14529915 3.85470085,6.40811966 3.85470085,5.5 C3.85470085,4.59188034 4.59188034,3.85470085 5.5,3.85470085 C6.40811966,3.85470085 7.14529915,4.59188034 7.14529915,5.5 C7.14529915,6.40811966 6.40811966,7.14529915 5.5,7.14529915 M5.5,3 C4.12179487,3 3,4.12179487 3,5.5 C3,6.87820513 4.12179487,8 5.5,8 C6.87820513,8 8,6.87820513 8,5.5 C8,4.12179487 6.87820513,3 5.5,3",
    id: "Fill-1",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25152863,9.80576973 C7.24569205,11.2383472 6.11145081,12.5583284 5.49694275,13.2518211 C4.99249583,12.6860714 3.80628127,11.3234789 2.74541412,9.80884164 C1.42773763,7.92916344 0.733740967,6.43277522 0.733740967,5.47470231 C0.733740967,2.85901121 2.87381879,0.732971395 5.5,0.732971395 C8.12618121,0.732971395 10.266259,2.86202229 10.266259,5.47470231 C10.266259,6.4266618 9.56920511,7.92612193 8.25152863,9.80576973 M5.5,0 C2.467204,0 0,2.45446112 0,5.4716304 C0,6.59394437 0.721511951,8.19377405 2.14313508,10.2224554 C3.26209005,11.8192436 4.51250695,13.2426662 4.99555309,13.7810119 C5.12395775,13.9239625 5.30433574,14 5.49694275,14 C5.68954975,14 5.86992774,13.9239625 5.99833241,13.7810119 C6.61284047,13.093663 7.79905503,11.718874 8.85075042,10.2194443 C10.2754308,8.18769104 11,6.59090287 11,5.4685889 C11,2.45141962 8.532796,0 5.5,0",
    id: "Fill-3",
    strokeWidth: 0.5
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.f24edb0c957ec58910e480b114a11749.svg";
export { ForwardRef as ReactComponent };